// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"V_5","reviews__wrapper__list":"V_dT","reviewSlider":"V_dV"};